import React from 'react';
import RichTextEditor from 'react-rte';

const CommonEditor = ({
    value,
    setValue,
    placeholder
}) => {
    const onChange = (value) => {
        setValue(value);
    }
    return (
        <RichTextEditor
            value={value}
            onChange={onChange}
            style={{
                marginBottom: '3px',
                border:
                    '1px solid lightgrey !important',
            }}
            placeholder={placeholder}
            editorStyle={{
                minHeight: '150px',
                fontSize: '14px',
            }}
        />
    )
}

export default CommonEditor;